import { render, staticRenderFns } from "./select-team-role.vue?vue&type=template&id=38d99a51&"
import script from "./select-team-role.vue?vue&type=script&lang=ts&"
export * from "./select-team-role.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports